import { render, staticRenderFns } from "./ApiBlock.vue?vue&type=template&id=0f62e207&scoped=true"
import script from "./ApiBlock.vue?vue&type=script&lang=js"
export * from "./ApiBlock.vue?vue&type=script&lang=js"
import style0 from "./ApiBlock.vue?vue&type=style&index=0&id=0f62e207&prod&lang=less&scoped=true"
import style1 from "./ApiBlock.vue?vue&type=style&index=1&id=0f62e207&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f62e207",
  null
  
)

export default component.exports